

export class VehicleCompanyOutputWithoutStatus implements IVehicleCompanyOutputWithoutStatus {
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id!: number;
    /** The vehicle type name with 255 character limit */
    vehicle_company_name!: string;

    constructor(data?: IVehicleCompanyOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_company_id = _data["vehicle_company_id"];
            this.vehicle_company_name = _data["vehicle_company_name"];
        }
    }

    static fromJS(data: any): VehicleCompanyOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCompanyOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_company_id"] = this.vehicle_company_id;
        data["vehicle_company_name"] = this.vehicle_company_name;
        return data; 
    }
}

export interface IVehicleCompanyOutputWithoutStatus {
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id: number;
    /** The vehicle type name with 255 character limit */
    vehicle_company_name: string;
}

